/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './drug-constraint.reducer';

export const DrugConstraintDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const drugConstraintEntity = useAppSelector(state => state.drugConstraint.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="drugConstraintDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.drugConstraint.detail.title">DrugConstraint</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.id">Id</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.description">Description</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.description}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.type">Type</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.type}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.value">Value</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.value}</dd>
          <dt>
            <span id="priority">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.priority">Priority</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.priority}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.unit}</dd>
          <dt>
            <span id="startConstraint">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.startConstraint">Start Constraint</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.startConstraint}</dd>
          <dt>
            <span id="endConstraint">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.endConstraint">End Constraint</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.endConstraint}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.active">Active</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.drugConstraint.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{drugConstraintEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.drugConstraint.drug">Drug</Translate>
          </dt>
          <dd>{drugConstraintEntity.drug ? drugConstraintEntity.drug.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/drug-constraint" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/drug-constraint/${drugConstraintEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DrugConstraintDetail;
